<div role="presentation" class="tt-popover__backdrop" ttOutsideClick (onOutsideClick)="ttOutsideClick.emit()" [style.--tt-popover-color]="ttPopoverBackgroundColor">
    <div role="dialog" class="tt-popover__window">
        <ng-container *ngIf="ttPopover" [ngTemplateOutlet]="ttPopover"></ng-container>
        <div class="tt-popover__arrow" [ngClass]="'tt-popover__arrow--' + ttPosition"></div>
    </div>
</div>
